import React, { useState } from 'react'
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu'
import EditMenu from '../editMenu'
import DeleteModal from '../../DeleteModal/DeleteModal'
import { withTheme } from 'theming'
import AddSection from '../addSection'
import CustomImage from '../../customImage/customImage'
import useTemplateHook from '../templateHook'
import { isEmpty } from 'lodash'

const FineTunedGalleryIkim = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const { data, id } = componentData

  const { customNavigate, getTemplateImage, EditIcon } = useTemplateHook()
  const [hoverState, setHoverState] = useState('')
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedCardIndex, setSelectedCardIndex] = useState('')

  const deleteCard = (index) => {
    setSelectedCardIndex(index)
    setDeleteModal(true)
  }

  const handleModal = (cardInfo, type, cardIndex, isEdit) => {
    setModalState({
      keyID: id,
      modalData: cardInfo,
      type: type,
      cardIndex: cardIndex,
      isEdit,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const onDeleteCard = () => {
    let tempdata = data
    tempdata?.card_data.splice(selectedCardIndex, 1)
    modifyData(id, tempdata)
    setDeleteModal(false)
    setSelectedCardIndex('')
  }

  const swapCards = (index, direction) => {
    let tempdata = data
    if (direction === 'right') {
      if (index < tempdata?.card_data.length - 1) {
        let temp = tempdata?.card_data[index]
        tempdata?.card_data.splice(index, 1)
        tempdata?.card_data.splice(index + 1, 0, temp)
      }
    } else if (direction === 'left') {
      if (index > 0) {
        let temp = tempdata?.card_data[index]
        tempdata?.card_data.splice(index, 1)
        tempdata?.card_data.splice(index - 1, 0, temp)
      }
    }
    modifyData(id, tempdata)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <div
      style={{ background: getStyleValue('component_background', 'primary_color', theme.c1) }}
      className={`w-full relative ${isEdit && hoverState && 'component-hover-class'}`}
      onMouseEnter={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onCopy={() => onCopy(id)}
        />
      )}
      <div className="w-full relative py-5 md:py-10">
        <div className="2xl:px-32 xl:px-24 md:px-16 sm:px-10 px-[0.5rem] w-full">
          <h2
            style={{
              color: getStyleValue('heading', 'color', theme.c3),
              fontFamily: getStyleValue('heading', 'font', ''),
              textAlign: getStyleValue('heading', 'alignment', ''),
            }}
            className={`w-full sm:text-3xl text-xl font-bold relative ${
              isEdit && hoverState === 'HEADING' && 'component-hover-class pr-10'
            } ${getStyleValue('heading', 'font_format', '')}`}
            onMouseOver={() => handleHoverItems('HEADING')}
            onMouseLeave={() => handleHoverItems('TOP')}
          >
            {data?.title}
            {hoverState === 'HEADING' && (
              <div
                className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-1 -right-3 flex justify-center items-center cursor-pointer"
                onClick={() => handleModal({ title: data?.title }, 'HEADING', 0, true)}
              >
                <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
              </div>
            )}
          </h2>
        </div>

        <ScrollMenu
          LeftArrow={LeftArrow}
          RightArrow={RightArrow}
          wrapperClassName="w-full mt-2 md:mt-4"
        >
          {data?.card_data.map((cardInfo, index) => (
            <Card
              key={index}
              itemId={`index${index}`}
              index={index}
              cardInfo={cardInfo}
              handleRedirect={handleRedirect}
              isEdit={isEdit}
              hoverState={hoverState}
              theme={theme}
              handleHoverItems={handleHoverItems}
              handleModal={handleModal}
              deleteCard={deleteCard}
              getTemplateImage={getTemplateImage}
              getStyleValue={getStyleValue}
              swapCards={swapCards}
            />
          ))}
        </ScrollMenu>
      </div>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
      {deleteModal && (
        <DeleteModal
          openModal={deleteModal}
          title={`Are you sure you want to delete this Card ?`}
          confirmButtonText={`Yes`}
          onCancel={() => {
            setSelectedCardIndex('')
            setDeleteModal(false)
          }}
          onConfirm={onDeleteCard}
        />
      )}
    </div>
  )
}

function LeftArrow() {
  const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext)
  const { FitnessPrev } = useTemplateHook()
  return (
    <button
      className={` absolute left-0 top-1/2 z-10  border-0 bg-transparent px-0 hidden lg:block`}
      disabled={isFirstItemVisible}
      onClick={() => scrollPrev()}
    >
      <img
        src={FitnessPrev}
        alt="prev"
        style={{
          width: '106px',
          height: '54px',
        }}
        // className="w-[54px] h-[54px] "
      />
    </button>
  )
}

function RightArrow() {
  const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext)
  const { FitnessNext } = useTemplateHook()
  return (
    <button
      className={` absolute right-0 top-1/2 z-10 border-0 bg-transparent px-0 hidden lg:block`}
      disabled={isLastItemVisible}
      onClick={() => scrollNext()}
    >
      <img
        src={FitnessNext}
        alt="next"
        style={{
          width: '106px',
          height: '54px',
        }}
      />
    </button>
  )
}

function Card({
  index,
  cardInfo,
  handleRedirect,
  isEdit,
  hoverState,
  theme,
  handleHoverItems,
  handleModal,
  deleteCard,
  swapCards,
  getTemplateImage,
  getStyleValue,
}) {
  const { PlusIcon, VideoPlaceholder } = useTemplateHook()
  return (
    <div key={index} className={`flex cursor-pointer`}>
      {!cardInfo?.is_multiple ? (
        <div
          style={{ color: theme.c7 }}
          className={`${isEdit && hoverState === `CARD${index}` && 'component-hover-class'}  ${
            !index && 'ml-2 2xl:ml-32 xl:ml-24 md:ml-16 sm:ml-10'
          } xl:h-[596px] sm:h-[518px] h-[209px] xl:w-[804px] sm:w-[700px] w-[282px] rounded-lg shadow-md overflow-hidden flex-shrink-0 mx-6 relative`}
          onMouseOver={() => handleHoverItems(`CARD${index}`)}
          onMouseLeave={() => handleHoverItems('TOP')}
          onClick={() => handleRedirect(cardInfo?.link)}
        >
          {hoverState === `CARD${index}` && (
            <div style={{ zIndex: 25 }} className={`relative `}>
              <div className={`mt-2 absolute w-full top-3 flex justify-center items-center`}>
                <span className={`text-[#2172eb] text-sm`}>{'804px X 596px'}</span>
              </div>

              <EditMenu
                onEdit={() => handleModal(cardInfo, 'CARD', index, true)}
                onDelete={() => deleteCard(index)}
                onMoveRight={() => swapCards(index, 'right')}
                onMoveLeft={() => swapCards(index, 'left')}
              />

              {/* <div className={`absolute w-full top-3 right-4  flex justify-end items-center`}>
                <div
                  className="mx-[8px] h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer"
                  onClick={() => handleModal(cardInfo, 'CARD', index, true)}
                >
                  <img src={EditIcon} className="w-[17px] h-[17px]" alt="editicon" />
                </div>
                <div
                  className="mx-[8px] h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer"
                  onClick={() => deleteCard(index)}
                >
                  <img src={TrashIcon} className="w-[17px] h-[17px]" alt="trashicon" />
                </div>
              </div> */}
            </div>
          )}
          <CustomImage
            imageUrl={getTemplateImage(cardInfo.image_s3key)}
            imgClass="w-full h-full"
            loaderClass="w-full h-full"
            loaderStyle={{ background: '#5A5A5A50' }}
            imgAlt={'card img'}
            errorPlaceholder={VideoPlaceholder}
          />
          <div
            style={{
              backgroundImage: `linear-gradient(to bottom, ${getStyleValue(
                'card_style',
                'background_color',
                theme.c3,
              )}, ${getStyleValue(
                'card_style',
                'background_color',
                theme.c3,
              )} 10%, rgba(0, 0, 0, 0))`,
            }}
            className="md:w-1/3 w-[130px] h-full px-[0.5rem] py-[0.5rem] md:px-5 md:py-7 absolute top-0 right-0"
          >
            <h2
              className={`2xl:text-[1.25vw] md:text-[1.3vw] text-[10px] md:font-semibold ${getStyleValue(
                'card_heading_style',
                'font_format',
                '',
              )}`}
              style={{
                color: getStyleValue('card_heading_style', 'color', ''),
                fontFamily: getStyleValue('card_heading_style', 'font', ''),
              }}
            >
              {cardInfo?.heading}
            </h2>
            <section
              className={`md:mt-6 2xl:text-[0.72916vw] sm:text-[0.8784vw] text-[9px] sm:font-normal font-light mobile-line-clamp-2 ${getStyleValue(
                'card_paragraph_style',
                'font_format',
                '',
              )}`}
              style={{
                color: getStyleValue('card_paragraph_style', 'color', ''),
                fontFamily: getStyleValue('card_paragraph_style', 'font', ''),
              }}
            >
              <p>{cardInfo?.description}</p>
            </section>
          </div>
        </div>
      ) : (
        <div
          style={{ color: theme.c7 }}
          className={`${isEdit && hoverState === `CARD${index}` && 'component-hover-class'} ${
            !index && 'ml-2 2xl:ml-32 xl:ml-24 md:ml-16 sm:ml-10'
          } 
        xl:h-[596px] sm:h-[518px] h-[209px] xl:w-[804px] sm:w-[700px] w-[282px] flex flex-col justify-between relative mx-6`}
          onMouseOver={() => handleHoverItems(`CARD${index}`)}
          onMouseLeave={() => handleHoverItems('TOP')}
        >
          {/* {hoverState === `CARD${index}` && (
            <div style={{ zIndex: 25 }} className={`relative `}>
              <div className={`absolute w-full top-3 right-4  flex justify-end items-center`}>
                <div
                  className="mx-[8px] h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer"
                  onClick={() => handleModal(cardInfo, 'CARD', index, true)}
                >
                  <img src={EditIcon} className="w-[17px] h-[17px]" alt="editicon" />
                </div>
                <div
                  className="mx-[8px] h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer"
                  onClick={() => deleteCard(index)}
                >
                  <img src={TrashIcon} className="w-[17px] h-[17px]" alt="trashicon" />
                </div>
              </div>
            </div>
          )} */}
          {hoverState === `CARD${index}` && (
            <EditMenu
              onEdit={() => handleModal(cardInfo, 'CARD', index, true)}
              onDelete={() => deleteCard(index)}
              onMoveRight={() => swapCards(index, 'right')}
              onMoveLeft={() => swapCards(index, 'left')}
            />
          )}

          {cardInfo?.card_a?.image_s3key && (
            <div
              className="absolute top-0 w-full"
              onClick={() => handleRedirect(cardInfo?.card_a?.link)}
            >
              <div className=" w-full xl:h-[278px] sm:h-[244px] h-[98px] overflow-hidden  rounded-lg shadow-md relative">
                {hoverState === `CARD${index}` && (
                  <div className={`mt-2 absolute w-full top-3 flex justify-center items-center`}>
                    <span className={`text-[#2172eb] text-sm`}>{'804px X 278px'}</span>
                  </div>
                )}
                <CustomImage
                  imageUrl={getTemplateImage(cardInfo?.card_a?.image_s3key)}
                  imgClass="w-full h-full"
                  loaderClass="w-full h-full"
                  loaderStyle={{ background: '#5A5A5A50' }}
                  imgAlt={'img a'}
                  errorPlaceholder={VideoPlaceholder}
                />
                <div
                  style={{
                    backgroundImage: `linear-gradient(to bottom, ${getStyleValue(
                      'card_style',
                      'background_color',
                      theme.c3,
                    )}, ${getStyleValue(
                      'card_style',
                      'background_color',
                      theme.c3,
                    )} 10%, rgba(0, 0, 0, 0))`,
                  }}
                  className="w-2/3 md:w-[47%] h-full px-[0.5rem] py-[0.5rem] md:pl-5 md:py-5 absolute top-0 right-0 "
                >
                  <h2
                    className={`2xl:text-[1.25vw] md:text-[1.3vw] text-[10px] md:font-semibold ${getStyleValue(
                      'card_heading_style',
                      'font_format',
                      '',
                    )}`}
                    style={{
                      color: getStyleValue('card_heading_style', 'color', ''),
                      fontFamily: getStyleValue('card_heading_style', 'font', ''),
                    }}
                  >
                    {cardInfo?.card_a?.heading}
                  </h2>
                  <section
                    className={`md:mt-2 2xl:text-[0.72916vw] sm:text-[0.8784vw] text-[9px] sm:font-normal font-light mobile-line-clamp-2 ${getStyleValue(
                      'card_paragraph_style',
                      'font_format',
                      '',
                    )} `}
                    style={{
                      color: getStyleValue('card_paragraph_style', 'color', ''),
                      fontFamily: getStyleValue('card_paragraph_style', 'font', ''),
                    }}
                  >
                    <p>{cardInfo?.card_a?.description}</p>
                  </section>
                </div>
              </div>
            </div>
          )}
          {cardInfo?.card_b?.image_s3key && (
            <div
              className="absolute bottom-0 w-full"
              onClick={() => handleRedirect(cardInfo?.card_b?.link)}
            >
              <div className=" w-full xl:h-[278px] sm:h-[244px] h-[98px] overflow-hidden rounded-lg shadow-md relative">
                {hoverState === `CARD${index}` && (
                  <div className={`mt-2 absolute w-full top-3 flex justify-center items-center`}>
                    <span className={`text-[#2172eb] text-sm`}>{'804px X 278px'}</span>
                  </div>
                )}
                <CustomImage
                  imageUrl={getTemplateImage(cardInfo?.card_b?.image_s3key)}
                  imgClass="w-full h-full"
                  loaderClass="w-full h-full"
                  loaderStyle={{ background: '#5A5A5A50' }}
                  imgAlt={'img b'}
                  errorPlaceholder={VideoPlaceholder}
                />
                <div
                  style={{
                    backgroundImage: `linear-gradient(to bottom, ${getStyleValue(
                      'card_style',
                      'background_color',
                      theme.c3,
                    )}, ${getStyleValue(
                      'card_style',
                      'background_color',
                      theme.c3,
                    )} 10%, rgba(0, 0, 0, 0))`,
                  }}
                  className="w-2/3 md:w-[47%] h-full px-[0.5rem] py-[0.5rem] md:pl-5 md:py-5 absolute top-0 right-0 "
                >
                  <h2
                    className={`2xl:text-[1.25vw] md:text-[1.3vw] text-[10px] md:font-semibold ${getStyleValue(
                      'card_heading_style',
                      'font_format',
                      '',
                    )}`}
                    style={{
                      color: getStyleValue('card_heading_style', 'color', ''),
                      fontFamily: getStyleValue('card_heading_style', 'font', ''),
                    }}
                  >
                    {cardInfo?.card_b?.heading}
                  </h2>
                  <section
                    className={`md:mt-2 2xl:text-[0.72916vw] sm:text-[0.8784vw] text-[9px] sm:font-normal font-light mobile-line-clamp-2 ${getStyleValue(
                      'card_paragraph_style',
                      'font_format',
                      '',
                    )}`}
                    style={{
                      color: getStyleValue('card_paragraph_style', 'color', ''),
                      fontFamily: getStyleValue('card_paragraph_style', 'font', ''),
                    }}
                  >
                    <p>{cardInfo?.card_b?.description}</p>
                  </section>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {isEdit && (
        <div className="rosemary-toptrending-add-button d-flex justify-content-center align-items-center py-2 z-20">
          <div style={{ border: '2.5px solid #2172eb' }} className="relative h-full">
            <div
              onClick={() => handleModal({}, 'CARD', index, false)}
              className="absolute h-[32px] w-[32px] rounded-full bg-[#2172eb] top-[45%] -left-4 flex justify-center items-center"
            >
              <img src={PlusIcon} className="w-[17px] h-[17px]" alt="plus icon" />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default withTheme(FineTunedGalleryIkim)
